module.exports = __webpack_public_path__ + "img/network-services.41214df6.jpg";